import React, { useState } from "react";
import axios from "axios";
import "../community.css";
import "../ai.css";
import { useParams, Link } from "react-router-dom";
import { updateDoc, doc, increment } from "firebase/firestore";
import { auth, db } from "../../firebase";


/* ==========================================================
   Resume Critique Tool
   ========================================================== */

function ResumeCritique() {
  const [resume, setResume] = useState("");
  const [analysis, setAnalysis] = useState("");
  const [loading, setLoading] = useState(false);
  const apiBase = process.env.REACT_APP_API_URL;

  const MAX_CHARS = 8000;

  /* ==========================================================
     Validate & Submit Resume
     ========================================================== */
  const analyzeResume = async () => {
    if (!resume.trim()) {
      alert("Paste your resume text first.");
      return;
    }

    if (resume.length > MAX_CHARS) {
      alert("Your resume is too long. Please shorten it or break it into sections.");
      return;
    }

    setLoading(true);
    setAnalysis("");

    try {
      const res = await axios.post(`${apiBase}/api/ai-resume-critique`, {
        resume,
      });

      setAnalysis(res.data.analysis);
    } catch (err) {
      console.error("Resume critique error:", err);
      setAnalysis("Error analyzing resume. Please try again.");
    }

    try {

  const user = auth.currentUser;

  if (user) {
    await updateDoc(doc(db, "users", user.uid), {
      "progress.resumeCritiques": increment(1)
    });
  }

} catch (err) {
  console.error("Critique progress update failed:", err);
}



    setLoading(false);
  };

  /* ==========================================================
     UI
     ========================================================== */

  return (
    <div className="ai-tool-wrapper">
      <Link to="/community">
  <button className="back-btn">← Back to Community</button>
</Link>
      <h2 className="ai-tool-title">📄 Resume Critique</h2>

      {/* RESUME INPUT */}
      <textarea
        className="ai-input"
        placeholder="Paste your resume text here... (no PDFs)"
        value={resume}
        onChange={(e) => setResume(e.target.value)}
        maxLength={MAX_CHARS}
      ></textarea>

      {/* CHARACTER COUNTER */}
      <div className="char-counter">
        {resume.length} / {MAX_CHARS}
      </div>

      {/* SUBMIT BUTTON */}
      <button className="ai-btn" onClick={analyzeResume} disabled={loading}>
        {loading ? "Analyzing..." : "Analyze Resume"}
      </button>

      {/* AI OUTPUT */}
      {analysis && (
        <div className="ai-output">
          <h3 className="ai-output-title">Analysis</h3>
          <pre className="ai-output-box">{analysis}</pre>
        </div>
      )}
    </div>
  );
}

export default ResumeCritique;

